// extracted by mini-css-extract-plugin
export default {"box":"ks8cNFAjHjXJP99HwrO2","mealPlanName":"RG6TJt0lPdbXrLwLnNHN","mealEditActions":"LS8bkVRuCGSCv6EL49MU"};